import { module } from "angular";
import { ProfileRepository } from "./ProfileRepository";

module("mmAuth").service("mmInternalProfileRepository", ProfileRepository);
